// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"b6a58d2a","405":"9870b5e3","647":"01073b35","705":"86e3981a","787":"871b41c3","837":"af55298f","888":"b439a99e","924":"40765119"}[chunkId] + ".chunk.js";
};